module.exports = __webpack_public_path__ + "media/printPropertySheet.a2ea2641.svg";